import React from 'react';

interface CarouselNextProps {
    fill?: string;
}

export const CarouselPrev = ({ fill = 'white' }: CarouselNextProps) => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1008_12297)">
            <g clipPath="url(#clip1_1008_12297)">
                <path
                    d="M12.5474 15.0533L5.96136 8.46733C5.83955 8.34066 5.77151 8.17174 5.77151 7.996C5.77151 7.82026 5.83955 7.65134 5.96136 7.52467L12.544 0.942667L11.6014 -4.1351e-08L5.0187 6.582C4.65535 6.96323 4.45266 7.46968 4.45266 7.99633C4.45266 8.52298 4.65535 9.02943 5.01869 9.41067L11.6047 15.996L12.5474 15.0533Z"
                    fill={fill}
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1008_12297">
                <rect
                    width="16"
                    height="16"
                    fill={fill}
                    transform="translate(0.5 16) rotate(-90)"
                />
            </clipPath>
            <clipPath id="clip1_1008_12297">
                <rect
                    width="16"
                    height="16"
                    fill={fill}
                    transform="translate(0.5 16) rotate(-90)"
                />
            </clipPath>
        </defs>
    </svg>
);
